import {
  Form,
  onFieldInputValueChange,
  onFieldValueChange
} from '@eastcoal/formily/exports/core'

import { SplitMethod } from '@eastcoal/shared/enums/SplitMethod'

import { MAX_DEAL_COUNT } from '../../constants/config'
import { PRICING_METHOD_FIELD, SPLIT_COUNT_FIELD } from '../../constants/field'

/**
 * 重置越界的拆分值
 *   1. 成交人数
 */
const resetOutOfBoundValue = (_: unknown, form: Form) => {
  const { dealCount = 0, splitValues } = form.values
  const newSplitValues = [...splitValues]
  for (let i = 0; i < MAX_DEAL_COUNT; i++) {
    // 重置越界的拆分数量
    if (dealCount < i + 1) {
      newSplitValues[i] = 0
    } else {
      newSplitValues[i] = newSplitValues[i] ?? 0
    }
  }
  form.setFieldState('splitValues', state => {
    state.value = newSplitValues
  })
}

/**
 * 设置拆分值的单位
 *   1. 成交数量方式
 *   2. 计价方式
 */
const updateUnit = (_: unknown, form: Form) => {
  const { splitMethod, quantityUnit } = form.values
  const unit = splitMethod === SplitMethod.PROPORTIONAL ? '%' : quantityUnit
  form.setFieldState('splitValues', state => {
    state.componentProps = {
      ...state.componentProps,
      unit
    }
  })
}

/**
 * 重置或者设置等额的拆分值
 *   1. 成交数量方式
 *   2. 数量
 *   3. 成交人数
 */
const resetOrSetEqualValue = async (_: unknown, form: Form) => {
  const { splitMethod, dealCount, quantity } = form.values

  if (!(quantity && dealCount && splitMethod === SplitMethod.EQUALLY)) {
    return
  }

  await form.validate('splitValues')

  const itemValue = quantity / dealCount

  const newValue = Array.from({ length: MAX_DEAL_COUNT }, () => itemValue).map(
    (value, index) => {
      return index > dealCount - 1 ? 0 : value
    }
  )

  form.setValuesIn('splitValues', newValue)
}

/**
 * 重置并禁用拆分值
 *  1. 是否整体拍
 */
const resetAndDisable = (_: unknown, form: Form) => {
  const { wholeSale } = form.values
  const disabled = !wholeSale
  form.setFieldState('splitValues', state => {
    state.disabled = disabled
    if (disabled) state.value = state.value.fill(0)
  })
}

/**
 * “拆分值”联动逻辑
 */
export const splitValuesEffect = () => {
  // 重置越界的拆分值
  onFieldInputValueChange('dealCount', resetOutOfBoundValue)

  // 更新拆分值的单位
  onFieldValueChange(PRICING_METHOD_FIELD, updateUnit)
  onFieldValueChange('splitMethod', updateUnit)

  // 重置或者设置等额的拆分值
  onFieldValueChange('quantity', resetOrSetEqualValue)
  onFieldValueChange('dealCount', resetOrSetEqualValue)
  onFieldValueChange('splitMethod', resetOrSetEqualValue)

  // “拆分拍模式”禁用
  onFieldValueChange(SPLIT_COUNT_FIELD, resetAndDisable)
}
